import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SmoothScroll from "@/components/layout/SmoothScroll";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import NoiseOverlay from "@/components/layout/NoiseOverlay";
import ScrollToTop from "@/components/layout/ScrollToTop";
import { AppHandoffProvider } from "@/components/layout/AppHandoff";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Simulator from "@/pages/Simulator";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import VIPPage from "@/pages/VIP";
import WhatWeDo from "@/pages/WhatWeDo";
import WhoWeAre from "@/pages/WhoWeAre";
import WhyCarbonis from "@/pages/WhyCarbonis";
import Security from "@/pages/Security";
import Methodology from "@/pages/Methodology";

function App() {
    return (
        <div className="App min-h-screen bg-paper text-navy">
            <BrowserRouter>
                <SmoothScroll>
                    <AppHandoffProvider>
                        <ScrollToTop />
                        <NoiseOverlay />
                        <Header />
                        <main>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/who-we-are" element={<WhoWeAre />} />
                                <Route path="/why-carbonis" element={<WhyCarbonis />} />
                                <Route path="/what-we-do" element={<WhatWeDo />} />
                                <Route path="/resources" element={<Insights />} />
                                <Route path="/resources/:slug" element={<InsightArticle />} />
                                <Route path="/simulator" element={<Simulator />} />
                                <Route path="/security" element={<Security />} />
                                <Route path="/methodology" element={<Methodology />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/vip" element={<VIPPage />} />
                                <Route path="/vip/:slug" element={<VIPPage />} />
                                {/* Legacy route redirects to preserve external links */}
                                <Route path="/about" element={<Navigate to="/who-we-are" replace />} />
                                <Route path="/platform" element={<Navigate to="/what-we-do" replace />} />
                                <Route path="/solutions" element={<Navigate to="/what-we-do" replace />} />
                                <Route path="/regulation" element={<Navigate to="/why-carbonis" replace />} />
                            </Routes>
                        </main>
                        <Footer />
                    </AppHandoffProvider>
                </SmoothScroll>
            </BrowserRouter>
        </div>
    );
}

export default App;
